/** Five-way fill-family selector; switching resets to that fill's defaults. */
import { FILLS, FILL_ORDER } from "../model/registry";
import { design, updateDesign } from "../state/store";

export function FillSelector() {
  const active = design.value.fill.kind;
  return (
    <div class="fill-selector">
      {FILL_ORDER.map((kind) => (
        <button
          key={kind}
          class={`fill-btn ${active === kind ? "active" : ""}`}
          onClick={() => {
            if (kind !== active) updateDesign((d) => ({ ...d, fill: FILLS[kind].defaults() }));
          }}
        >
          {FILLS[kind].label}
        </button>
      ))}
    </div>
  );
}
